import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import AppsIcon from "@mui/icons-material/Apps";
import Drawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import { Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { SideDrawer } from "./SideDrawer";
import { getStaticFileUrl } from "./utils/config";

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const menuItems = ["HOME", "ABOUT US", "PORTFOLIO", "CONTACT"];
  const paths = ["/", "/about", "/portfolio", "/contact"];

  useEffect(() => {
    const currentIndex = paths.findIndex((path) => path === location.pathname);
    setSelectedTab(currentIndex >= 0 ? currentIndex : 0);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = (index) => {
    setSelectedTab(index);
    navigate(paths[index]);
    setDrawerOpen(false);
  };

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: isScrolled ? "#FFFFFF" : "transparent",
          transition: "background-color 0.3s ease-in-out",
          boxShadow: isScrolled ? "0px 4px 6px rgba(0,0,0,0.1)" : "none",
          borderBottom: isScrolled ? "2px solid rgba(0,0,0,0.1)" : "2px solid rgba(255,255,255,0.2)",
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "1.5rem 0" }}>
          <Button onClick={() => handleClick(0)} sx={{ padding: 0, minWidth: 0, backgroundColor: "transparent" }}>
            <img
              src={getStaticFileUrl(`/img/${isScrolled ? "logo_color.png" : "logo.png"}`)}
              height={15}
              width={163.15}
              alt="logo"
              style={{ marginLeft: "24px", transition: "none" }}
            />
          </Button>

          {!isMobile && (
            <Box sx={{ display: "flex", position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
              {menuItems.map((item, index) => (
                <Typography
                  key={item}
                  onClick={() => handleClick(index)}
                  variant="body2"
                  sx={{
                    color: isScrolled ? "#000000" : "#FFFFFF",
                    fontWeight: "bold",
                    cursor: "pointer",
                    fontSize: "0.875rem",
                    mx: 2,
                    "&:hover": { color: "#333333" },
                  }}
                >
                  {item}
                </Typography>
              ))}
            </Box>
          )}

          <IconButton edge="end" aria-label="menu" sx={{ color: isScrolled ? "#000000" : "#FFFFFF", marginRight: "24px" }} onClick={toggleDrawer(true)}>
            {isMobile ? <MenuIcon /> : <AppsIcon />}
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        sx={{
          "& .MuiDrawer-paper": {
            width: isMobile ? "70%" : "350px",
            backgroundColor: "#FFFFFF",
            padding: "16px",
          },
        }}
      >
        {isMobile ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              padding: "15px",
            }}
            role="presentation"
            onClick={toggleDrawer(false)}
          >
            {menuItems.map((item, index) => (
              <Typography
                key={item}
                onClick={() => handleClick(index)}
                variant="body2"
                sx={{
                  fontWeight: "bold",
                  cursor: "pointer",
                  fontSize: "0.875rem",
                  padding: "10px 0",
                  color: "#555555",
                  "&:hover": { color: "#000000", backgroundColor: "#f0f0f0" },
                }}
              >
                {item}
              </Typography>
            ))}
          </Box>
        ) : (
          <SideDrawer />
        )}
      </Drawer>
    </>
  );
}

export default Header;
